import { StoreAppInfo } from "./types";

type PlayStoreJsonResponse = {
  packageID?: string;
  name?: string;
  version?: string;
  logo?: string;
  lastUpdated?: string;
  rating?: string;
  noOfUsersRated?: string;
  downloads?: string;
};

/**
 * Unofficial but CORS-friendly Play metadata API.
 * Richer than /version — returns name, logo, version, downloads, lastUpdated, etc.
 * https://github.com/rajkumaar23/playstore-api
 */
export async function fetchAndroidAppInfo(
  packageId: string,
): Promise<StoreAppInfo> {
  try {
    const response = await fetch(
      `https://play.rajkumaar.co.in/json?id=${encodeURIComponent(
        packageId,
      )}&gl=NL`,
    );

    if (!response.ok) {
      throw new Error(response.statusText || `HTTP ${response.status}`);
    }

    const data = (await response.json()) as PlayStoreJsonResponse;

    if (!data?.packageID && !data?.version && !data?.name) {
      return {
        platform: "android",
        status: "offline",
        error: "Not found on Play Store",
      };
    }

    const rating =
      data.rating && data.noOfUsersRated
        ? `${data.rating} (${data.noOfUsersRated})`
        : data.rating || undefined;

    return {
      platform: "android",
      status: "online",
      name: data.name,
      version: data.version,
      iconUrl: data.logo,
      storeUrl: `https://play.google.com/store/apps/details?id=${encodeURIComponent(
        packageId,
      )}&gl=NL`,
      lastUpdated: data.lastUpdated || undefined,
      rating,
    };
  } catch (error) {
    return {
      platform: "android",
      status: "offline",
      error: error instanceof Error ? error.message : "Lookup failed",
    };
  }
}
